import { createSelector } from 'reselect';
import _get from 'lodash/get';
import { getLatestJob } from 'lib/selectors/getLatestJob';

const getLatestJobName = createSelector([getLatestJob], (latestJob) => {
  return _get(latestJob, 'displayName', '');
});

export { getLatestJobName };
